import { Button, type ButtonProps, IconQrScan } from "@fhs/ui";
import { Link } from '@fhs/link';

export type ScanButtonProps = Omit<ButtonProps, "children">;

export function ScanButton(props: ScanButtonProps) {
  return (
    <Link href="/redeem">
      <Button type="outline" aria-label="Open loyalty code" size="xs" {...props}>
        <Button.Icon>
          <IconQrScan />
        </Button.Icon>

        <Button.Text>Scan</Button.Text>
      </Button>
    </Link>
  );
}
